import { Tabs } from "antd";
import { RouteChildrenProps } from "react-router";
import i18n from "../../../../utils/i18n";
import AssetClassesConfiguration from "./asset-classes";
import "./index.scss";
import RatingConfiguration from "./rating";
import VariablesConfiguration from "./variables";

const { TabPane } = Tabs;

enum TabKeyEnum {
    Variables = "Variables",
    AssetClasses = "AssetClasses",
    Rating = "Rating"
}


interface Props extends RouteChildrenProps { }

const ScenarioFrontierConfiguration = (props: Props) => {

    const tabs = [{
        key: TabKeyEnum.Variables,
        name: i18n.t("ScenarioFrontier.lbVariables"),
        content: VariablesConfiguration
    },
    {
        key: TabKeyEnum.AssetClasses,
        name: i18n.t("ScenarioFrontier.lbAssetClasses"),
        content: AssetClassesConfiguration
    },
    {
        key: TabKeyEnum.Rating,
        name: i18n.t("ScenarioFrontier.lbRating"),
        content: RatingConfiguration
    }]

    const tabChanged = (tab: TabKeyEnum) => {

    }

    return (
        <div className="scenario-frontier-configuration">
            <Tabs defaultActiveKey={TabKeyEnum.Variables} onChange={activeKey => { tabChanged(activeKey as TabKeyEnum) }}>
                {tabs.map((item) =>
                    <TabPane
                        tab={<>{item.name} </>}
                        key={item.key}>
                        <item.content />
                    </TabPane>)}
            </Tabs>
        </div>
    )
}

export default ScenarioFrontierConfiguration;